<template>
  <div class="issueadd" v-dragDiv v-show="addShow">
    <div class="addTitle moveDragDiv">
      <span>空间</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-tree ref="tree" :expand-on-click-node="false" class="navTree" :data="datatree" :props="defaultProps" @node-click="nodeClick">
        <div slot-scope="{ node, data }" class="warp">
          <div v-if="node.level === 1" :title="node.label">{{node.label}}</div>
          <div v-else class="nodeRow" :title="node.label">
            <img v-show="isShowMark(data)" class="select" :src="require('./../images/空间系统选中.png')" alt="选中">
            <div class="name">{{node.label}}</div>
            <img v-show="isShowMark(data)" class="target" :src="require('./../images/定位.png')" alt="定位">
          </div>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name:'spaceTree',

  data () {
    return {
      addShow:false,
      datatree:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      oldData:{}
    }
  },

  methods : {
    openArea(){
      if (!this.datatree[0]) {
        this.datatree = []
        const modelInfo = Monge.Model.getModels() || []
        const [info] = modelInfo
        info.label = info.name
        info.children = Monge.Model.Tree.getLevelTree() || []
        this.datatree.push(info)
      }
      this.addShow = true;
    },

    closeArea(){
      this.addShow = false
    },

    isShowMark (data) {
      const {elementID,levelID} = data
      const {elementID:oldElementID,levelID:oldLevelID} = this.oldData
      return elementID ? elementID === oldElementID : levelID === oldLevelID && elementID === oldElementID
    },

    nodeClick (data,node) {
      if (node.level === 1) return
      const {elementID,levelID} = data
      const {elementID:oldElementID,levelID:oldLevelID} = this.oldData
      Monge.Model.AreaPlane.clear()
      Monge.Model.Space.removeBoxByLevel()
      if (elementID) {
        if (oldElementID === elementID) {
          Monge.Model.Camera.fitToHome(() => {

          })
          return this.oldData = {}
        }
        Monge.Model.AreaPlane.create(elementID, 0xE75200)
        Monge.Model.AreaPlane.enter(elementID)
      } else {
        if (levelID === oldLevelID && elementID === oldElementID) {
           Monge.Model.Camera.fitToHome(() => {

           })
           return this.oldData = {}
        }
        Monge.Model.Space.createBoxByLevel(levelID,0xE75200,0.5)
        Monge.Model.AreaPlane.fitToLevel({levelID})
      }
      this.oldData = data
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.issueadd {
  position: absolute;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    height calc(100% - 50px)
    overflow-y auto
    /deep/ .el-tree{
      .warp{
        width 100%
        .nodeRow{
          width 100%
          display flex
          align-items center
          position relative
          .select{
            position absolute
            left 0
            top 50%
            transform translateY(-50%)
          }
          .name{
            width 90%
            padding-left 10px
          }
        }
      }
    }
  }
}
</style>
